import { createMutation, createTriggerResource } from '@magicdoorinc/ui';
import { createMagicDoorContext } from '~/contexts/utils';
import { LeaseRecurringCreditRepository } from '~/repositories/leaseRecurringCreditRepository';
import type { CreateRecurringLeaseCreditDto, UpdateRecurringLeaseCreditDto } from '~/swagger/portal/Api';
export const [LeaseRecurringCreditProvider, useLeaseRecurringCredit] = createMagicDoorContext('LeaseRecurringCredit', () => {
  const repo = new LeaseRecurringCreditRepository();

  const [recurringCredits, getRecurringCredits, { refetch: refetchRecurringCredits }] = createTriggerResource(async (leaseId: string) => {
    const response = await repo.getRecurringCredits(leaseId);
    return response.recurringCredits;
  });

  const addRecurringCredit = createMutation(async (params: { leaseId: string; payload: CreateRecurringLeaseCreditDto }) => {
    const response = await repo.addRecurringCredit(params.leaseId, params.payload);
    refetchRecurringCredits();
    return response;
  });

  const deleteRecurringCredit = createMutation(
    async (params: { leaseId: string; recurringCreditId: string; deleteAllCredits: boolean }) => {
      await repo.deleteRecurringCredit(params.leaseId, params.recurringCreditId, params.deleteAllCredits);
      refetchRecurringCredits();
    }
  );

  const updateLeaseRecurringCredit = createMutation(
    async (params: { leaseId: string; recurringCreditId: string; payload: UpdateRecurringLeaseCreditDto }) => {
      await repo.updateLeaseRecurringCredit(params.leaseId, params.recurringCreditId, params.payload);
      refetchRecurringCredits();
    }
  );

  return {
    recurringCredits,
    getRecurringCredits,
    addRecurringCredit,
    deleteRecurringCredit,
    updateLeaseRecurringCredit,
  };
});
